import { Canvas } from 'modules/common/Canvas';
import { PopupContextModel } from 'modules/common/components/PopupContext';
import useBroadcaster from 'modules/common/hooks/useBroadcaster';
import { UserCompany } from '../models/orgs';

interface SwitchedCompanyPopupProps {
  org: UserCompany;
  popupContext: PopupContextModel;
}

export const SwitchedCompanyPopup: React.FC<SwitchedCompanyPopupProps> = (props) => {
  const closeSwitcherNotifier = useBroadcaster('close-switcher-notif-popup', () => props.popupContext.closeAll());

  const closeAndNotify = () => {
    props.popupContext.closeAll();
    closeSwitcherNotifier.dispatch();
  };

  return (
    <Canvas.Modal.Body>
      <p>
        Your company has been switched to <strong>{props.org.organizationName}</strong>.
      </p>
      <Canvas.PrimaryButton onClick={closeAndNotify}>OK</Canvas.PrimaryButton>
    </Canvas.Modal.Body>
  );
};
